import { defineFcm } from '../shared/factory';

export const FCM_ALLOW_IDENTIFIED_USER_FETCH_PETITION_LISTS = defineFcm('allow_identified_user_fetch_petition_lists')
	.asBoolean()
	.withDefault(false)
	.toConfig();
